import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CardContainer,
  ButtonRemove,
  DivRemove,
  Quantity,
  ButtonSelector,
} from "./style";
import { BsTrash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

interface CardProductProps {
  id: number;
  image: string;
  title: string;
  price: number;
  qtd_carbon: number;
  minQty: number;
  maxQty: number;
  deleteItem: () => void;
  updateQuantity: (newQty: number) => void;
}

const CardProduct: React.FC<CardProductProps> = ({
  id,
  image,
  title,
  price,
  qtd_carbon,
  minQty,
  maxQty,
  deleteItem,
  updateQuantity,
}) => {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(qtd_carbon);
  const navigate = useNavigate();

  useEffect(() => {
    setQuantity(qtd_carbon);
  }, [qtd_carbon]);

  const increment = () => {
    if (quantity <= maxQty) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      updateQuantity(newQuantity);
    }
  };

  const decrement = () => {
    if (quantity > minQty) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      updateQuantity(newQuantity);
    }
  };

  return (
    <div className="flex justify-between items-start gap-5 !text-xl !text-[#50700F] ml-[2%]">
      <div style={{ display: "flex" }}>
        <div>
          <img
            src={image}
            alt={title}
            style={{
              width: "377px",
              height: "247px",
              borderRadius: "15px",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate(`/detailsPropertySeller/${id}`);
            }}
          />
        </div>
        <div className="">
          <h2 className="!text-2xl !font-medium">{title}</h2>
          {/*                    <p style={{ marginTop: "80px" }}>
                        R${" "}
                        {price.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                        })}
                    </p>*/}
        </div>
      </div>

      <div
        className="flex-col items-start justify-between"
        style={{ cursor: "default" }}
      >
        <h2 className="!text-2xl !font-medium">Quantidade</h2>
        <div className="flex pt-4" >
          <ButtonSelector onClick={decrement}>-</ButtonSelector>
          <Quantity>{quantity}</Quantity>
          <ButtonSelector onClick={increment}>+</ButtonSelector>
        </div>
      </div>
      <div className="">
        <h2 className="!text-2xl">Total</h2>
        <p style={{ marginTop: "80px" }}>
          R${" "}
          {price.toFixed(2)}
        </p>
        <DivRemove>
          <ButtonRemove onClick={deleteItem}>
            <BsTrash size={25} style={{ color: "red" }} />
            {t("remove")}
          </ButtonRemove>
        </DivRemove>
      </div>
    </div>
  );
};

export default CardProduct;
